"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONSUMER_EMAIL_DOMAINS = void 0;
/**
 * Free/consumer email providers. These domains can never be bound to an org and never
 * count as a company-domain match. Used by the api (addDomain, auto-join) and the web
 * (contact access defaults).
 */
exports.CONSUMER_EMAIL_DOMAINS = new Set([
    "gmail.com",
    "googlemail.com",
    "outlook.com",
    "hotmail.com",
    "live.com",
    "msn.com",
    "yahoo.com",
    "ymail.com",
    "icloud.com",
    "me.com",
    "mac.com",
    "aol.com",
    "proton.me",
    "protonmail.com",
    "gmx.com",
    "mail.com",
    "zoho.com",
    "yandex.com",
]);
